import styled from 'styled-components';

import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Modal from 'components/modal';

import theme from './theme';

export const Background = styled.div`
  background: ${theme.modalBackground};
  width: 100%;
`;

export const Inner = styled.div`
  max-width: 485px;
  width: 90%;
  margin: 0 auto;
  background: ${theme.modalBackground};
  color: ${theme.innerColor};
  padding-top: 20px;

  > * {
    width: 100%;
    display: block;
  }

  p {
    margin: 0 0 1rem 0;
    color: ${theme.innerPColor};
    line-height: 1.4;
    font-size: 0.9375rem;
    text-transform: capitalize;
  }

  h2,
  h3 {
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.base};
    margin: 0;
    text-transform: capitalize;
  }

  h3 {
    margin-bottom: 14px;
  }

  a {
    color: ${theme.innerAnchorColor};
    font-weight: 500;
    font-size: 0.875rem;
    text-decoration: underline;
    cursor: pointer;
  }
`;

export const Address = styled.div`
  font-size: 0.9375rem;
  color: ${theme.addressColor};
  text-transform: capitalize;
  line-height: 1.4;
`;

export const PhoneNumber = styled.a`
  color: ${theme.phoneNumberColor};
  line-height: 1.4;
  font-size: 0.9375rem;
`;

export const Amenity = styled.div`
  margin-bottom: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  > svg {
    margin-right: 5px;
    width: 30px;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const SpacingLine = styled.div<{ bottom: number; top: number }>`
  border-top: 1px solid rgba(177, 177, 177, 0.7);
  margin-top: ${p => p.top}px;
  margin-bottom: ${p => p.bottom}px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  border-top: 1px solid rgba(177, 177, 177, 0.7);
  width: 100%;
  height: 81px;
  display: flex;
  align-items: center;
  background: ${theme.modalBackground};

  ${Styles.mobileFullscreen`
    /* using the full safe-area inset makes this component too tall */
    padding-bottom: calc(env(safe-area-inset-bottom) / 2);
  `}
`;

export const StoreHourContainer = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: space-between;
`;

export const AddressAndPhone = styled.div`
  * {
    font-size: 1rem !important;
    line-height: 1.5;
  }

  a:first-of-type {
    font-weight: bold;
  }
`;

export const StoreModal = styled(Modal)`
  ${Styles.desktop`
    &&& {
      width: ${Styles.layout.smallerSectionMaxWidth};
    }
  `};
`;

export const FeatureIcon = styled.img`
  margin-right: 0.3em;
  height: 1.5em;
  width: 1.9em;
`;

export const LoyaltyTagsContainer = styled.div`
  display: flex;
`;

export const LoyaltyTag = styled.div`
  display: flex;
  line-height: 1.25rem;
  background: ${Styles.color.cardBackground};
  padding: 0.2rem 0.7rem;
  margin: 0.5rem 0.5rem 0.5rem 0;
  font-size: 0.8rem;
  border-radius: 0.4rem;
`;

export const StyledLoyaltyIcon = styled(LoyaltyPointsIcon)`
  margin-right: 0.5rem;
`;
